import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            userCurrentContext: 'userCurrentContext'
        }),

        userId () {
            return this.userCurrentContext.userMember.muser
        },

        currentGroup () {
            return _.get(this.userCurrentContext, 'group')
        },

        currentOrgId () {
            return _.get(this.userCurrentContext, 'organization.id')
        },

        isOrgManagerOrAdmin () {
            return this.getIsOrgManagerOrAdmin(this.currentOrgId, this.currentGroup ? [this.currentGroup.id] : [])
        },

        isAllowedToSharePerson () {
            if (!this.person) {
                return false
            }

            const orgId = this.person._id
                ? (_.get(this.person, 'organizationOwner.id') || _.get(this.person, 'organizationOwner'))
                : _.get(this.userCurrentContext, 'organization.id') // when creating new person
            const sharingGroups = this.person.sharingGroups || []
            const currentGroup = _.get(this.userCurrentContext, 'group')
            if (!this.person._id && currentGroup) {
                sharingGroups.push(currentGroup)
            }

            return this.getIsOrgManagerOrAdmin(orgId, sharingGroups.map((g) => g.id))
        },

        isAllowedToCreateOrEditPerson () {
            if (!this.person) {
                return false
            }

            const orgId = (_.get(this.person, 'organizationOwner.id') || _.get(this.person, 'organizationOwner'))
            const sharingGroups = this.person.sharingGroups || []

            return this.getIsOrgManagerOrAdmin(orgId, sharingGroups.map((g) => g.id)) ||
                (this.person.createdBy && this.person.createdBy.id === this.userId)
        }
    },

    methods: {
        getIsOrgManagerOrAdmin (orgId, groupIds) {
            const isManager = _.get(this.userCurrentContext, 'userMember.isManager')
            const isOrgAdmin = _.get(this.userCurrentContext, 'userMember.isOrgAdmin')
            const currentOrgId = _.get(this.userCurrentContext, 'organization.id')
            const currentGroupId = _.get(this.userCurrentContext, 'group.id')

            return (currentOrgId === orgId || groupIds.includes(currentGroupId)) &&
                (isManager || isOrgAdmin)
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/userPermission.js